module.exports = __webpack_public_path__ + "3c7a8b247f9d448a6d9f315bbc2d0ab9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-1.png
// module id = 1589
// module chunks = 0